import React from "react";
import { FormattedMessage } from "react-intl";

import { Button, glyphs } from "@treelab/panda";

import { Container, Mask, Content, Header, Title, Message, Footer } from "./styled";

export interface IModal {
  onClose: () => void;
  onSubmit: () => void;
  onReject: () => void;
  titleId: string;
  messageId?: string;
}

const Modal: React.FC<IModal> = ({ titleId, onClose, onSubmit, messageId, onReject }) => {
  return (
    <Container>
      <Mask onClick={onClose} />
      <Content>
        <Header>
          <Title>
            <FormattedMessage id={titleId} />
          </Title>
          <Button buttonType="text" icon={glyphs.CLOSE_V2} isWithBackgroundColor={false} onClick={onClose} />
        </Header>
        {messageId && (
          <Message>
            <FormattedMessage id={messageId} />
          </Message>
        )}
        <Footer>
          <Button onClick={onReject} buttonType="outline">
            <FormattedMessage id="form.button.modal.close" />
          </Button>
          <Button onClick={onSubmit}>
            <FormattedMessage id="form.button.modal.submit" />
          </Button>
        </Footer>
      </Content>
    </Container>
  );
};

export default Modal;
